export default {
  day: 'Day',
  delay: 'Delay',
  delete: 'Delete',
  details: 'Details',
  discard: 'Discard',
  discard_changes: 'Discard Changes',
  dnsName: 'DNS Name',
  down: 'Down',
  duration: 'Duration'
}
